/**
 * Pluggable key-value store. Spec §4.3 uses wallet-origin localStorage in
 * production; tests pass in an in-memory implementation.
 */
export interface KeyValueStore {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

/** Adapter for `window.localStorage`. Falls back to in-memory if unavailable. */
export function browserLocalStorage(): KeyValueStore {
  const w = (globalThis as any).window;
  if (w?.localStorage) {
    return w.localStorage as KeyValueStore;
  }
  // SSR / Node fallback — small in-memory map, not persistent.
  const mem = new Map<string, string>();
  return {
    getItem: (k) => mem.get(k) ?? null,
    setItem: (k, v) => {
      mem.set(k, v);
    },
    removeItem: (k) => {
      mem.delete(k);
    },
  };
}
